module.exports = __webpack_public_path__ + "pcsg/media/a.1aceb1bf.mp4";